var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Wrap as ChakraWrap, WrapItem as ChakraWrapItem, } from "@chakra-ui/react";
/**
 * Wrap is a layout component used to add space between elements and wraps automatically if there isn't enough space.
 */
const Wrap = forwardRef((_a, ref) => {
    var { className, shouldWrapChildren = true } = _a, rest = __rest(_a, ["className", "shouldWrapChildren"]);
    return (React.createElement(ChakraWrap, Object.assign({}, rest, { ref: ref, className: className, shouldWrapChildren: shouldWrapChildren })));
});
Wrap.displayName = "Wrap";
const WrapItem = ChakraWrapItem;
export default Wrap;
export { WrapItem };
//# sourceMappingURL=Wrap.js.map